import React from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export const AppointmentsSection = ({
  appointments,
  handleAppointmentStatus,
  openEditAppointment,
}) => (
  <AccordionItem
    value="appointments"
    className="bg-background border border-border rounded-lg"
  >
    <AccordionTrigger className="px-4 sm:px-6 py-4 hover:no-underline">
      <div className="flex items-center gap-3">
        <Calendar className="w-5 h-5 text-primary" />
        <span className="font-bold text-base">
          Citas Agendadas ({appointments.length})
        </span>
      </div>
    </AccordionTrigger>
    <AccordionContent>
      <div className="px-4 sm:px-6 pb-4 max-h-[500px] overflow-y-auto">
        {appointments.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-sm text-muted-foreground">
              No hay citas agendadas
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {appointments.map((apt) => (
              <div
                key={apt.id}
                className="p-3 bg-muted/30 rounded-lg border border-border"
              >
                <div className="flex items-start justify-between flex-wrap gap-2">
                  <div>
                    <p className="font-medium text-sm">{apt.client_name}</p>
                    <p className="text-xs text-muted-foreground">
                      {apt.date} a las {apt.time_slot} | {apt.development_name}
                      {apt.unit_number && ` - Unidad ${apt.unit_number}`}
                    </p>
                  </div>
                  <div className="flex gap-2 flex-wrap">
                    <span
                      className={`text-xs px-2 py-1 rounded-full ${
                        apt.status === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : apt.status === "confirmed"
                            ? "bg-green-100 text-green-700"
                            : apt.status === "denied"
                              ? "bg-red-100 text-red-700"
                              : "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {apt.status === "pending"
                        ? "Pendiente"
                        : apt.status === "confirmed"
                          ? "Confirmada"
                          : apt.status === "denied"
                            ? "Denegada"
                            : apt.status}
                    </span>
                    {apt.status === "pending" && (
                      <>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() =>
                            handleAppointmentStatus(apt.id, "confirmed")
                          }
                        >
                          Aceptar
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() =>
                            handleAppointmentStatus(apt.id, "denied")
                          }
                        >
                          Denegar
                        </Button>
                      </>
                    )}
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => openEditAppointment(apt)}
                    >
                      Editar
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AccordionContent>
  </AccordionItem>
);
